"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeLogType = {
    unknown: 0,
    pricing: 1
};
exports.default = exports.ChangeLogType;
